const ENV_MAP = {
  'mobile.my-desk.ch': {
    name: 'MyDesk Mobile',
    shortName: 'MyDesk',
    manifest: '/manifest.json',
  },
  'mobile-test.my-desk.ch': {
    name: 'Test MyDesk Mobile',
    shortName: 'Test',
    manifest: '/manifest-test.json',
  },
  'mobile-testnembrisilk.my-desk.ch': {
    name: 'TestNS MyDesk Mobile',
    shortName: 'TestNS',
    manifest: '/manifest-testns.json',
  },
  localhost: {
    name: 'Local MyDesk Mobile',
    shortName: 'Local',
    manifest: '/manifest-local.json',
  },
};

function normalizeHostname(hostname) {
  if (hostname === '127.0.0.1' || hostname === '[::1]') {
    return 'localhost';
  }
  return hostname;
}

export function getPwaEnv(hostname = window.location.hostname) {
  const normalized = normalizeHostname(hostname);
  const env = ENV_MAP[normalized];
  if (env) {
    return {
      hostname: normalized,
      name: env.name,
      shortName: env.shortName,
      manifest: env.manifest,
    };
  }
  return {
    hostname: normalized,
    name: 'MyDesk Mobile',
    shortName: 'MyDesk',
    manifest: '/manifest.json',
  };
}

export function applyPwaManifest() {
  const { name, manifest } = getPwaEnv();
  document.title = name;

  let link = document.querySelector('link[rel="manifest"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'manifest';
    document.head.appendChild(link);
  }
  link.href = manifest;
}

export async function refreshApp() {
  try {
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }
  } catch (err) {
    console.error(err);
  }

  const url = new URL(window.location.href);
  url.searchParams.set('_', String(Date.now()));
  window.location.replace(url.toString());
}
